/**
 * Reads X-Effective-Chat-Llm-Provider from streaming chat responses (requires CORS expose_headers).
 */
export function logEffectiveChatModelFromResponse(res: Response, label?: string): void {
  const provider = res.headers.get('X-Effective-Chat-Llm-Provider')
  if (!provider) return
  const where = label ? ` (${label})` : ''
  console.log(`[Athena] Active chat model${where}:`, provider)
}
